import applyProjects from 'reducers/applyProjects'

export default function partiallyApplyProjects(state, action) {
  const { projects } = action
  return Object.assign({}, state, {
    projects: [
      ...(state.projects || []),
      ...applyProjects({}, { projects }).projects
    ]
  })
}



// WEBPACK FOOTER //
// ./src/reducers/partiallyApplyProjects.js